import React from "react";
import { CheckIcon } from "lucide-react";
type CheckListProps = {
  items: string[];
  dark?: boolean;
  columns?: boolean;
};
export function CheckList({
  items,
  dark = false,
  columns = false
}: CheckListProps) {
  return <ul className={`grid gap-3 ${columns ? "sm:grid-cols-2" : ""}`} data-id="element-19" data-mp="3cny4xlz3qkkj">
      {items.map(item => <li key={item} className="flex items-start gap-3" data-id="element-20" data-mp="38mw81bsnqklq">
          <span className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-mint" data-id="element-21" data-mp="33p30offmbkjv">
            <CheckIcon className="h-4 w-4 text-white" strokeWidth={3} aria-hidden="true" data-id="element-22" data-mp="2yxcp664y2qqv" />
          </span>
          <span className={`text-[16px] font-medium leading-snug ${dark ? "text-white" : "text-ink"}`} data-id="element-23" data-mp="2ty02pmhzjlot">{item}</span>
        </li>)}
    </ul>;
}